import _ from 'lodash'
import { Input } from '../input'
import Icon from '../icon'
import { KeyCode } from '../../core/KConstants'
import { Tag } from '../tag'

// import $ from 'jquery'

export default {
  name: 'KSelectInput',
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    selectedOption: {
      validator: () => true,
      default() {
        return null
      },
    },
    placeholder: {
      type: String,
      default: '',
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    size: {
      validator: (value) => ['large', 'normal', 'small', 'mini'].indexOf(value) !== -1,
      default: 'normal',
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    pure: {
      type: Boolean,
      default: false,
    },
    hideIndicator: {
      type: Boolean,
      default: false,
    },
    inputable: {
      type: Boolean,
      default: false,
    },
    inputValue: {
      type: String,
      default: '',
    },
    prefix: {
      // 前缀图标
      type: String,
      default: '',
    },
  },
  data() {
    return {
      focused: false,
      inputToken: '',
    }
  },
  computed: {
    hasValue() {
      if (this.multiple) {
        return this.selectedOption.length > 0
      }
      return !_.isNil(this.selectedOption)
    },
  },
  watch: {
    inputToken(value) {
      this.$emit('inputToken', value)
    },
    inputValue(value) {
      this.inputToken = value
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    handleLabelClear(option) {
      this.$emit('action:labelClick', option)
    },
    renderLabels() {
      if (!this.hasValue && !this.pure) {
        return
      }
      if (this.$slots.default || this.pure) {
        return this.$slots.default
      }

      if (!this.multiple) {
        return
      }

      const labels = _.map(this.selectedOption, (option, index) => {
        return this.renderLabel(option, index)
      })

      return (<div class="km-select-labels">
        {labels}
      </div>)
    },
    renderLabel(option, index) {
      if (!this.multiple) {
        const option = this.selectedOption
        if (!option) {
          return ''
        }
        return option.label || option.value
      }

      return <Tag
        key={index}
        class="km-select__label"
        size="small"
        clearable
        onClear={() => {
          this.handleLabelClear(option)
        }}
        nativeOnClick={(e) => {
          e.stopPropagation()
        }}
      >
        {option.label || option.value}
      </Tag>
    },
    renderArrow() {
      if (this.hideIndicator) {
        return
      }

      return (
        <template slot="suffix">
          <Icon
            icon="chevron-down"
            class="km-select__arrow"
          />
        </template>
      )
    },
    handleKeydown(e) {
      const keyCode = e.which
      if (keyCode === KeyCode.TAB) {
        return true
      }
      if (!this.inputable) {
        e.preventDefault()
      }

      this.$emit('action:keydown', keyCode)
    },
    focus() {
    },
  },
  render() {
    const selectCss = {
      'km-select': true,
      'km-select--pure': this.pure,
      'km-select--multiple': this.multiple,
      'is-active': this.active || this.focused,
      'km-select--active': this.active,
    }

    const style = {}
    if (this.multiple) {
      style.height = 'auto'
    }

    const events = {
      focus: () => {
        this.focused = true
        this.$emit('action:inputFocus')
      },
      blur: () => {
        this.focused = false
        this.$emit('action:inputBlur')
      },
      clear: (e) => {
        e && e.stopPropagation()
        this.$emit('action:clear')
      },
    }

    const nativeEvents = {
      keydown: this.handleKeydown,
    }

    const props = {
      value: this.hasValue ? 1 : null,
      clearable: this.clearable,
      clearSuffix: true,
      clearableOnHover: true,
      disabled: this.disabled,
      loading: this.loading,
      size: this.size,
      'original-readonly': !this.inputable,
    }

    if (!this.multiple) {
      props.value = this.renderLabel()
    }

    if (this.prefix) {
      props.prefix = this.prefix
    }

    const attrs = {
      placeholder: this.placeholder,
    }

    const data = {
      class: selectCss,
      style: style,
      on: events,
      nativeOn: nativeEvents,
      ref: 'input',
      props: props,
      attrs: attrs,
    }

    const labels = this.renderLabels()

    const arrow = this.renderArrow()

    if (this.inputable) {
      delete props.value
      return <Input
        ref="input"
        vModel={this.inputToken}
        {...data}>
        {labels}
        {arrow}
      </Input>
    }

    return <Input
      ref="input"
      {...data}>
      {labels}
      {arrow}
    </Input>
  },
}
